import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { TAX_KEY, TAX_KEY_NAME } from "../../utils/Utils";

const TAX_KEY_OPTIONS = [TAX_KEY.SELL_OUT_0, TAX_KEY.SELL_OUT_NON_FILING, TAX_KEY.SELL_OUT_10, TAX_KEY.SELL_OUT_8].map((c) => ({
  label: TAX_KEY_NAME[c],
  value: c,
}));


const DEFAULT_TAX = {
  id: null,
  date: moment().format("YYYY-MM-DD"),
  purchaseValue: 0,
  inputVAT: 0,
  value: 0,
  type: "SELL_OUT_0",
  outputVAT: 0,
};

const TaxManager = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditedId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [deleteId, setDeleteId] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get("start")
      ? moment(searchParams.get("start")).startOf("days").toDate()
      : moment().startOf("year").toDate(),
    end: searchParams.get("end")
      ? moment(searchParams.get("end")).endOf("days").toDate()
      : moment().add(1, "month").endOf("year").toDate(),
  });

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY") || "",
    },

    {
      Header: "Giá trị mua vào",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.purchaseValue || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
          displayType="text"
        />
      ),
    },
    {
      Header: "Thuế GTGT đầu vào",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.inputVAT || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
          displayType="text"
        />
      ),
    },
    {
      Header: "Giá trị",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.value || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
          displayType="text"
        />
      ),
    },
    {
      Header: "Loại thuế",
      accessor: (item) => TAX_KEY_NAME[item.type]
    },
    {
      Header: "Thuế GTGT đầu ra",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.outputVAT || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
          displayType="text"
        />
      ),
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.content
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      ...DEFAULT_TAX,
    },
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setTimeNow(moment().valueOf());
    }
  };

  const value = useWatch({
    control,
    name: "value",
  });

  const type = useWatch({
    control,
    name: "type",
  });

  useEffect(() => {
    if (type == "SELL_OUT_0" || type == "SELL_OUT_NON_FILING")
      return setValue("outputVAT", 0);
    if (type == "SELL_OUT_10")
      return setValue("outputVAT", ((value || 0) * 10) / 100);
    return setValue("outputVAT", ((value || 0) * 8) / 100);
  }, [value, type]);

  useEffect(() => {
    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.end).format("YYYY-MM-DD"),
    };

    GET(`/tax`, params, true)
      .then(({ data }) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset({
      ...DEFAULT_TAX,
    });
    setEditedId();
    setDeleteId();
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/tax/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const formData = getValues();
    const request = editId
      ? PUT(`/tax/${editId}`, formData, {}, true)
      : POST("/tax", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteTax = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/tax/${id}`, {}, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý thuế"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Thuế</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          placeholderText="Lọc theo ngày"
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm thuế</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm thuế</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            max={moment().format("YYYY-MM-DD")}

                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="date"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Giá trị mua vào
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="purchaseValue"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="purchaseValue"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Thuế GTGT đầu vào
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="inputVAT"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="inputVAT"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Giá trị
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="value"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="value"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Loại thuế
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="type"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={TAX_KEY_OPTIONS}
                                value={TAX_KEY_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="type"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Thuế GTGT đầu ra
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="outputVAT"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                                disabled
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="outputVAT"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label">Ghi chú</label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="content"
                            render={({ onChange, value, ref }) => (
                              <textarea
                                className="form-control"
                                style={{ minHeight: "100px" }}
                                ref={ref}
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                              ></textarea>
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="content"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Xác nhận</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá thuế này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteTax(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default TaxManager;
